import { getMerchant } from '@/services/merchants';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ModelMerchantResponse } from '@layup/api-sdk';

export const useMerchantStore = defineStore('merchants', {
  state: () => {
    const merchant = ref<ModelMerchantResponse>({});
    const activeMerchantId = ref('');

    return {
      merchant,
      activeMerchantId,
    };
  },
  actions: {
    async onChangeMerchant(merchantId: string) {
      this.activeMerchantId = merchantId;
      const merchantResponse = await getMerchant(merchantId);
      this.merchant = merchantResponse;
    },
    setMerchant(merchantData: ModelMerchantResponse) {
      this.merchant = merchantData;
    },
    onResetMerchant() {
      this.activeMerchantId = '';
      this.merchant = {};
    },
    reset() {
      this.$reset();
    },
  },
  persist: true,
});
